import { useState, useEffect, useRef, useCallback } from 'react';

const TARGET_FPS = 30;
const FRAME_DURATION = 1000 / TARGET_FPS;

export function useFrameCounter(running = true) {
    const [frame, setFrame] = useState(0);
    const startTimeRef = useRef(null);
    const rafRef = useRef(null);

    useEffect(() => {
        if (!running) return;

        startTimeRef.current = performance.now();

        const tick = (now) => {
            const elapsed = now - startTimeRef.current;
            const newFrame = Math.floor(elapsed / FRAME_DURATION);
            setFrame(newFrame);
            rafRef.current = requestAnimationFrame(tick);
        };

        rafRef.current = requestAnimationFrame(tick);

        return () => {
            if (rafRef.current) cancelAnimationFrame(rafRef.current);
        };
    }, [running]);

    const reset = useCallback(() => {
        startTimeRef.current = performance.now();
        setFrame(0);
    }, []);

    return { frame, fps: TARGET_FPS, reset };
}
